<div class="font-bold mb-3" i18n>
  Generic Bootstrapping Architecture (GBA) is a technology that enables user authentication. GBA authenticates by making a network component
  (e.g., Network Application Functions - NAF) challenge the eSIM and verifying that its response is expected by the core network (e.g.,
  HLR/HSS).
</div>
<div class="font-bold mb-3" i18n>Does your IMS network support GBA for the user authentication?</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleUpdate($event)"
          name="profileValues.isimConfiguration.gbaUserAuthentication"
          inputId="profileValues.isimConfiguration.gbaUserAuthentication#1"
          value="1"
          [(ngModel)]="profileValues.isimConfiguration.gbaUserAuthentication"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="profileValues.isimConfiguration.gbaUserAuthentication#1" i18n>Yes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleUpdate($event)"
          name="profileValues.isimConfiguration.gbaUserAuthentication"
          inputId="profileValues.isimConfiguration.gbaUserAuthentication#0"
          value="0"
          [(ngModel)]="profileValues.isimConfiguration.gbaUserAuthentication"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="profileValues.isimConfiguration.gbaUserAuthentication#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
